import { render, staticRenderFns } from "./model-sort.vue?vue&type=template&id=ecfe2c70&scoped=true&"
import script from "./model-sort.vue?vue&type=script&lang=js&"
export * from "./model-sort.vue?vue&type=script&lang=js&"
import style0 from "./model-sort.vue?vue&type=style&index=0&id=ecfe2c70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfe2c70",
  null
  
)

export default component.exports